import routeName from '@/router/constant';

export const payaccHeader = [
    {
        path: 'payAcc-policy-list',
        name: routeName.PAYACC_POLICY,
        component: () => import('@/views/payacc/landingPage/list.vue'),
        meta: {
            auth: true,
            metaTitle: '給付帳號約定',
            pageTitle: '給付帳號約定',
            unableBack: true,
        },
        // beforeEnter: (to, from, next) => {
        //     const whiteList = [routeName.CONTACT_INFO, routeName.FINISH, routeName.TWID_RESULT];
        //     const guideRoute = guideRoutes(from, whiteList, true);
        //     next(guideRoute);
        // },
    },
    {
        path: 'payAcc-set-account',
        name: routeName.PAYACC_SELECT_POLICY,
        component: () => import('@/views/payacc/landingPage/Index.vue'),
        meta: {
            auth: true,
            metaTitle: '給付帳號約定',
            pageTitle: '給付帳號約定',
            isNeedPolicyCard: true,
            unableBack: true,
        },
    },
    {
        path: 'payAcc-confirm',
        name: routeName.PAYACC_CONFIRM,
        component: () => import('@/views/payacc/dataConfirm/Index.vue'),
        meta: {
            auth: true,
            metaTitle: '給付帳號約定',
            pageTitle: '給付帳號約定',
            backPage: routeName.PAYACC_CONFIRM,
            // code,
            isNeedPolicyCard: true,
            unableBack: true,
        },
    },
    {
        path: 'payAcc-finish',
        name: routeName.PAYACC_FINISH,
        component: () => import('@/views/payacc/finish/Index.vue'),
        meta: {
            auth: true,
            metaTitle: '委託受理完成',
            leaveAlert: false,
            pageTitle: '委託受理完成',
            unableBack: false,
        },
    },
];
